<template>
    <router-view></router-view>
    <!-- <div class="vertical grow">
         <ul class="main-submenu-bar submenu-alarms visible">
            <div>
                <router-link class="menuitem" :to="{name: 'visitsList'}" tag="li">
                    <router-link-icon-horizontal :routerName="'visitsList'" :text="$t('Visits')">
                        <img src="@/assets/img/Systems/Roughage.svg" />
                    </router-link-icon-horizontal>
                </router-link>
            </div>
            <div>
                <router-link class="menuitem" :to="{name: 'problems'}" tag="li">
                    <router-link-icon-horizontal :routerName="'problems'" :text="$t('Problems')">
                        <img src="@/assets/img/Systems/Roughage.svg" />
                    </router-link-icon-horizontal>
                </router-link>
            </div>
            <div>
                <router-link class="menuitem" :to="{name: 'solutions'}" tag="li">
                    <router-link-icon-horizontal :routerName="'solutions'" :text="$t('Solutions')">
                        <img src="@/assets/img/Systems/Roughage.svg" />
                    </router-link-icon-horizontal>
                </router-link>
            </div>
        </ul>
        <div class="content-container scrollbar-full">
            <router-view></router-view>
        </div>
    </div> -->
</template>

<script>
import RouterLinkIconHorizontal from "../components/RouterLinkIconHorizontal.vue"

export default
{
    components: { RouterLinkIconHorizontal },
    mounted: function ( ) {
      this.$router.push({
        name: "visitsList"
      });
    }
}
</script>

<style>
.main-submenu-bar .menuitem, .main-submenu-bar .menuitem a {
    max-width: 200px;
    float: left;
    color: white;
    text-align: center;
    font-size: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
      width: 100%;
    height: 100%;
}

.main-submenu-bar .menuitem.active, .main-submenu-bar .menuitem.active a {
    color: yellow;
}

.main-submenu-bar .menuitem a:before {
    content: "";
    /* background: url("~@/assets/img/alarm1icon.png") no-repeat; */
    display: inline-block;
    width: 18px;
    height: 18px;
    background-size: 18px 18px;
    margin: 0 6px 0 0
}

.main-menu-bar .menuitem a {
    display: flex;
    justify-content: center;
    align-items: center;

}

.main-submenu-bar .icon {
    margin-right: 10px;
    width: 16px;
    height: 16px;
    vertical-align: unset;
}

.main-submenu-bar .menuitem {
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-submenu-bar li.router-link-exact-active .selected{
    border-bottom: 4px solid white !important;
    margin-bottom: 0px;
    border-radius: 15px;
    width: 120%;
}
</style>

<style scoped>
ul {
    margin-bottom: 0;
}

.submenu-alarms {
    grid-template-columns: repeat(10, minmax(160px, 200px));
}

.main-submenu-bar {
    clear: both;
    width: 100%;
    height: 52px;
    background: #007d95;
    display: none;
    list-style-type: none;
}

.main-submenu-bar.visible {
    display: grid;
}

.main-submenu-bar {
    padding-left: 0px;
    /* position:fixed;  */
    width:100vw;
    height: 52px;
    left: 0;
    top: calc(51px + 32px);
    z-index: 3;
}

.main-submenu-bar .icon-button {
    margin-bottom: 4px;
}

.main-submenu-bar li.router-link-exact-active .icon-button{
    margin-bottom: 0px;
}

.scrollbar-full {
    overflow-y: auto;
    overflow-x: hidden;
}

.scrollbar-full::-webkit-scrollbar-track
{
    border: 1px solid #A3D4E0;
	-webkit-box-shadow: 0 0 6px rgba(0,0,0,0.3);
	border-radius: 3px;
	background-color: white;
}

.scrollbar-full::-webkit-scrollbar
{
	width: 10px;
	background-color: white;
}

.scrollbar-full::-webkit-scrollbar-thumb
{
	border-radius: 3px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: rgb(0, 149, 178);
}
</style>



// WEBPACK FOOTER //
// src/views/VisitsView.vue